module.exports = __webpack_public_path__ + "img/newslogo.74a95307.png";